import * as S from './styles';
import { FunnelSimple } from '@phosphor-icons/react';

interface IProps {
    name_button: string;
    isActive: boolean;
    onClick: () => void;
}
export default function ButtonFilterTable({ name_button, isActive, onClick }: IProps) {
    return (
        <S.Container
            className={isActive ? 'active' : ''}
            onClick={onClick}
        >
            <FunnelSimple size={24} />
            {name_button}
        </S.Container>
    )
}